import { Button, Grid, makeStyles, Snackbar, Typography } from '@material-ui/core';
import { User, UserRole } from '../../../domain/domain';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ApplicationState } from '../../../reducers';
import { compose } from "redux";
import { connect } from "react-redux";
import NotFound from '../../../components/NotFound';
import { ConfirmationDialog } from '../../../components/Dialogs/ConfirmationDialog';
import { exportCrsToXML } from '../../../api/title';
import { Alert } from "../../Alert/Alert";

const useStyles = makeStyles(_ => ({
    root: {
        marginTop: 100
    },
    nav: {
        marginTop: 50
    },
    button: {
        textTransform: 'none',
        color: '#186ea8',
        fontSize: 24,
        fontWeight: 300,
        '&:hover': {
            backgroundColor: 'inherit',
            color: '#2e9e9e'
        }
    }
}));


type Props = {
    currentUser: User
}

const AdministratorPage: React.FC<Props> = ({ currentUser }) => {
    const classes = useStyles();
    const history = useHistory();
    const [exportCrsConfirmationDialogOpen, setExportCrsConfirmationDialogOpen] = useState<boolean>(false);
    const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
    const [snackBarMessage, setSnackBarMessage] = useState<string>("");
    const [snackBarSeverity, setSnackBarSeverity] = useState<"success" | "error">("success");
    const exportCrs = () => {
        setExportCrsConfirmationDialogOpen(true);
    }

    if (currentUser.userRole !== UserRole.ADMINISTRATOR) {
        return <NotFound />
    }

    return (
        <>
            <Snackbar open={snackBarOpen} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={() => { setSnackBarOpen(false) }}>
                <Alert onClose={() => { setSnackBarOpen(false) }} severity={snackBarSeverity}>
                    {snackBarMessage}
                </Alert>
            </Snackbar>
            <ConfirmationDialog
                open={exportCrsConfirmationDialogOpen}
                title="Export CRS to XML"
                contentText="Are you sure you want to export all CRS titles to XML; this is a long running process?"
                handleNo={() => {
                    setExportCrsConfirmationDialogOpen(false);
                }}
                handleYes={() => {
                    exportCrsToXML();
                    setExportCrsConfirmationDialogOpen(false);
                    setSnackBarSeverity("success");
                    setSnackBarMessage("The export is in progress. You will receive an email when the export is complete.");
                    setSnackBarOpen(true);
                }}
            />
            <Grid container direction='column' alignContent='center' spacing={5} alignItems='center' className={classes.root}>
                <Grid item>
                    <Typography variant='h1'>Administrator Page</Typography>
                </Grid>
                <Grid item className={classes.nav}>
                    <Grid container direction='column' alignItems='center'>
                        <Grid item>
                            <Button size="large" className={classes.button} onClick={() => {
                                history.push("/crs")
                            }}>Last Published Date</Button>
                        </Grid>
                        {currentUser.userRole === UserRole.ADMINISTRATOR &&
                            <Grid item>
                                <Button size="large" className={classes.button} onClick={() => {
                                    history.push("/admin/users")
                                }}>User Management</Button>
                            </Grid>
                        }
                        {currentUser.userRole === UserRole.ADMINISTRATOR &&
                            <Grid item>
                                <Button size="large" className={classes.button} onClick={() => {
                                    history.push("/marked-for-deletion")
                                }}>Content Marked For Deletion</Button>
                            </Grid>
                        }
                        {currentUser.userRole === UserRole.ADMINISTRATOR &&
                            <Grid item>
                                <Button size="large" className={classes.button} onClick={() => {
                                    history.push("/editorial-templates")
                                }}>Edit Editorial Templates</Button>
                            </Grid>
                        }
                        {currentUser.userRole === UserRole.ADMINISTRATOR &&
                            <Grid item>
                                <Button size="large" className={classes.button} onClick={() => { exportCrs() }}>Export CRS to XML</Button>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        currentUser: state.user.currentUser
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return { dispatch };
}

export default compose<any>(
    connect(mapStateToProps, mapDispatchToProps)
)(AdministratorPage);